import React, {useEffect,useState,useRef,useMemo } from 'react';
import JobCard from './jobCard';
import { FiSearch, FiInfo } from 'react-icons/fi';
import Loader from '../../../common/loader';
import { Search, ChevronDown, ChevronUp, Filter, X,SlidersHorizontal } from 'lucide-react';
import { set } from 'lodash';
import unifiedAuthManager from '../../../services/unifiedAuthManager';

const JobList = ({ jobs,candidateId,resumecandidate,onApplyJob, onMenuChange,isLoading,onPageChange,isValidate,isMore,applyingJobId,sectors,countries,onSelectionChange,  onSearchChange,totalJobs }) => {
  const [searchTerm, setSearchTerm] = React.useState('');
  const [filteredJobs, setFilteredJobs] = React.useState(jobs);
  const [currentMenu,setCurrentMenu]=useState('All')
  const [visibleCount, setVisibleCount] = useState(12);
   const divRef = useRef(null);
  const [isAtBottom, setIsAtBottom] = useState(false);
  const [count, setCount] = useState(1);
   const searchTimeoutRef = useRef(null);
   const modalRef = useRef(null);
     const isAuthed = unifiedAuthManager.isAuthenticated();
  // Semantic search: simple case-insensitive match on title, company, and description



const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSectors, setSelectedSectors] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [sectorSearch, setSectorSearch] = useState('');
  const [countrySearch, setCountrySearch] = useState('');
  const [sectorsExpanded, setSectorsExpanded] = useState(true);
  const [countriesExpanded, setCountriesExpanded] = useState(true);
    const [selectedCountryNames, setSelectedCountryNames] = useState([]);
    const [tempSelectedSectors, setTempSelectedSectors] = useState([]);
  const [tempSelectedCountries, setTempSelectedCountries] = useState([]);
  const totalAppliedFilters = selectedSectors.length + selectedCountries.length;



  useEffect(() => {
  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      cancelModal();
    }
  };

  if (isModalOpen) {
    document.addEventListener('mousedown', handleClickOutside);
  }

  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [isModalOpen, selectedSectors, selectedCountries]);

const hasFiltersChanged = useMemo(() => {
  const sectorsChanged = 
    tempSelectedSectors.length !== selectedSectors.length ||
    !tempSelectedSectors.every(id => selectedSectors.includes(id)) ||
    !selectedSectors.every(id => tempSelectedSectors.includes(id));
  
  const countriesChanged = 
    tempSelectedCountries.length !== selectedCountries.length ||
    !tempSelectedCountries.every(code => selectedCountries.includes(code)) ||
    !selectedCountries.every(code => tempSelectedCountries.includes(code));
  
  return sectorsChanged || countriesChanged;
}, [tempSelectedSectors, tempSelectedCountries, selectedSectors, selectedCountries]);

  const openModal = () => {
    // Copy current applied filters to temp state when opening modal
    setTempSelectedSectors([...selectedSectors]);
    setTempSelectedCountries([...selectedCountries]);
    setIsModalOpen(true);
  };


 const filteredSectors = useMemo(() => {
    return sectors.filter(sector =>
      sector.name.toLowerCase().includes(sectorSearch.toLowerCase())
    );
  }, [sectorSearch]);

  const filteredCountries = useMemo(() => {
    return countries.filter(country =>
      country.name.toLowerCase().includes(countrySearch.toLowerCase())
    );
  }, [countrySearch]);

  const handleSectorToggle = (sectorId) => {
    setTempSelectedSectors(prev =>
      prev.includes(sectorId)
        ? prev.filter(id => id !== sectorId)
        : [...prev, sectorId]
    );
  };
const cancelModal = () => {
    // Discard temp selections
    setIsModalOpen(false);
       setTempSelectedSectors([...selectedSectors]);
    setTempSelectedCountries([...selectedCountries]);
    setSectorSearch('');
    setCountrySearch('');
  };

 const handleCountryToggle = (countryCode) => {
    const country = countries.find(c => c.code === countryCode);
    setTempSelectedCountries(prev =>
      prev.includes(countryCode)
        ? prev.filter(code => code !== countryCode)
        : [...prev, countryCode]
    );
    // setSelectedCountryNames(prev =>
    //   prev.includes(country.name)
    //     ? prev.filter(name => name !== country.name)
    //     : [...prev, country.name]
    // );
  };


  const clearAllSectors = () => setSelectedSectors([]);
  const clearAllCountries = () => setSelectedCountries([]);
  
  const clearAll = () => {
    setSelectedSectors([]);
    setSelectedCountries([]);
  setIsModalOpen(false);
  };

  // const applyFilters = () => {
  //   console.log('Applied Filters:', { selectedSectors, selectedCountries });
  //    onSelectionChange({
  //     sectors: selectedSectors,
  //     countries: selectedCountryNames
  //   });
  //   setIsModalOpen(false);
  // };
  const applyFilters = () => {
    // Apply temp selections to main state
    setSelectedSectors([...tempSelectedSectors]);
    setSelectedCountries([...tempSelectedCountries]);

      const countryNames = tempSelectedCountries.map(code => {
      const country = countries.find(c => c.code === code);
      return country?.name;
    }).filter(Boolean);
    
     onSelectionChange({
      sectors: tempSelectedSectors,
      countries: countryNames
    });


    
    // Get names for sectors
    // const sectorNames = tempSelectedSectors.map(id => {
    //   const sector = sectors.find(s => s.id === id);
    //   return sector?.name;
    // }).filter(Boolean);
    // setSelectedSectorNames(sectorNames);
    
    // // Get names for countries
    // const countryNames = tempSelectedCountries.map(code => {
    //   const country = countries.find(c => c.code === code);
    //   return country?.name;
    // }).filter(Boolean);
    // setSelectedCountryNames(countryNames);
    
    // console.log('Applied Filters:', { 
    //   selectedSectors: tempSelectedSectors, 
    //   selectedCountries: tempSelectedCountries,
    //   selectedSectorNames: sectorNames,
    //   selectedCountryNames: countryNames
    // });
    
    setIsModalOpen(false);
    setSectorSearch('');
    setCountrySearch('');
  };

  // const totalFilters = selectedSectors.length + selectedCountries.length;







  useEffect(()=>{
 console.log('all my jobs',jobs)
  },[jobs])
useEffect(() => {
  // Clear any existing timeout
  if (searchTimeoutRef.current) {
    clearTimeout(searchTimeoutRef.current);
  }

  // Only trigger API search for "All Jobs" menu
  if (currentMenu === 'All') {
    // Debounce the search by 500ms
    searchTimeoutRef.current = setTimeout(() => {
      console.log('Triggering API search:', searchTerm);
      onSearchChange({menu:'All', term: searchTerm});
    }, 500);
  }else if(currentMenu === 'Recommended'){
     searchTimeoutRef.current = setTimeout(() => {
      console.log('Triggering API search:', searchTerm);
      onSearchChange({menu:'Recommended', term: searchTerm});
    }, 500);
  }

  // Cleanup timeout on unmount or when dependencies change
  return () => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
  };
}, [searchTerm, currentMenu]);

// Client-side filtering for Recommended/Applied and updating filteredJobs
useEffect(() => {
  if (currentMenu !== 'All') {
    // For Recommended and Applied menus, use client-side filtering
    if (!searchTerm.trim()) {
      setFilteredJobs(jobs);
      return;
    }

    const lower = searchTerm.toLowerCase();
    setFilteredJobs(
      jobs.filter(job =>
        (job.title && job.title.toLowerCase().includes(lower)) ||
        (job.company_name && job.company_name.toLowerCase().includes(lower)) ||
        (job.mph_city && job.mph_city.toLowerCase().includes(lower)) ||
        (job.vacancy && job.vacancy.toString().toLowerCase().includes(lower))
      )
    );
  } else {
    // For "All Jobs", just update filteredJobs with the jobs from API
    setFilteredJobs(jobs);
  }
}, [jobs, searchTerm, currentMenu]);

  const setMenu=(item)=>{
  try {
    setIsModalOpen(false)
    console.log('current menu',currentMenu,item)
    if(currentMenu!==item){

       if(item==='All'){
        onSelectionChange({
      sectors: [],
      countries: []
    });

    }
       console.log('current menu',currentMenu,item)
    setCurrentMenu(item)
     setSearchTerm(''); 
     setTempSelectedCountries([]);
     setTempSelectedSectors([]);
     setSelectedCountries([]);  // Add this line
     setSelectedSectors([]);  
      onMenuChange(item);
    }
  } catch (error) {
    console.log(error)
  }
 }

 

 const handleScroll = () => {
  if( currentMenu === 'All'){
    const div = divRef.current;
    if (!div) return;

    const isBottom =
      div.scrollTop + div.clientHeight >= div.scrollHeight - 5;

    if (isBottom && !isAtBottom &&isMore) {
      setIsAtBottom(true);
      
     const newValue = count + 1; // calculate immediately
    setCount(newValue);         // update state (asynchronously)
    onPageChange(newValue);
       onPageChange()
    } else if (!isBottom && isAtBottom) {
      setIsAtBottom(false); // reset when user scrolls up again
    }
  }else if(currentMenu === 'Recommended'){
        const div = divRef.current;
    if (!div) return;

    const isBottom =
      div.scrollTop + div.clientHeight >= div.scrollHeight - 5;

    if (isBottom && !isAtBottom &&isMore) {
      setIsAtBottom(true);
      
     const newValue = count + 1; // calculate immediately
    setCount(newValue);         // update state (asynchronously)
    onPageChange(newValue);
    onPageChange()
    } else if (!isBottom && isAtBottom) {
      setIsAtBottom(false); // reset when user scrolls up again
    }
  }
  };



  return (
    <section className="flex-grow w-full h-full flex flex-col">
      {/* Fixed Header */}
      <div className="flex-shrink-0">
        <div className="relative mb-6 flex items-center justify-center">
          <div className="relative flex w-3/4 rounded-full items-center gap-2 px-2 shadow-md ">
            <input 
  type="text" 
  placeholder="Search for jobs" 
  value={searchTerm}
  onChange={e => setSearchTerm(e.target.value)}
  className="w-full rounded-full py-2 pl-5 pr-8 text-xs border-0 focus:outline-none focus:ring-0 placeholder:text-gray-999"
/>
            <FiSearch className=" text-gray-400 mph-primary" />
{currentMenu==='All'&&( 
            <div onClick={()=>setIsModalOpen(true)} title='Filter' className="realtive">
               <SlidersHorizontal  className=" cursor-pointer w-4 h-4 text-gray-400 mph-primary" />
               {totalAppliedFilters > 0 && (
              <span className="absolute -top-1 -right-1 bg-[#B2853D] text-white text-[0.5rem] font-bold rounded-full w-3 h-3 flex items-center justify-center">
                {totalAppliedFilters}
              </span>
            )}
             {isModalOpen && (
          <div ref={modalRef} className="bg-white right-[1rem] top-[2.2rem] absolute z-10 w-[15rem] md:w-auto rounded-lg shadow-xl   max-h-[70vh] flex flex-col">
            {/* Modal Header */}
            <div className="flex items-center justify-between px-2 py-1.5 border-b border-gray-200">
              <h2 className="text-sm font-bold text-gray-900">Filters</h2>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                {/* <X size={14} /> */}
              </button>
            </div>

            {/* Modal Content */}
            <div className="flex-1 overflow-y-auto px-2 py-1.5 scrollbar-thin scrollbar-hide">
              <div className="grid grid-cols-1 md:grid-cols-2  gap-3">
                {/* Sectors Filter */}
                <div className="bg-gray-50 px-2 rounded-lg border border-gray-200">
                  <div 
                    className=" border-b border-gray-200 flex items-center justify-between cursor-pointer hover:bg-gray-100"
                    
                  >
                    {/*onClick={() => setSectorsExpanded(!sectorsExpanded)} */ }
                    <div className="flex items-center gap-2">
                      <h3 className="text-xs font-semibold py-1 text-gray-900">Sectors</h3>
                      {tempSelectedSectors.length > 0 && (
                        <span className="bg-blue-100 text-blue-700 text-xs font-medium px-1.5 p-0.5 rounded-full">
                          {tempSelectedSectors.length}
                        </span>
                      )}
                    </div>
                    {/* {sectorsExpanded ? <ChevronUp size={14} /> : <ChevronDown size={14} />} */}
                  </div>
                  
                  {sectorsExpanded && (
                    <div className="p-2 flex flex-col gap-2">
                      <div className="relative ">
                        <Search className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-400" size={12} />
                        <input
                          type="text"
                          placeholder="Search sectors..."
                          value={sectorSearch}
                          onChange={(e) => setSectorSearch(e.target.value)}
                          className="w-full pl-6 pr-4 py-1 text-[0.7rem] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        />
                      </div>

                      {/* {selectedSectors.length > 0 && (
                        <button
                          onClick={clearAllSectors}
                          className="text-xs text-blue-600 hover:text-blue-700 font-medium mb-3"
                        >
                          Clear all
                        </button>
                      )} */}

                      <div className="max-h-[12rem] overflow-y-auto space-y-2">
                        {filteredSectors.map((sector) => (
                          <label
                            key={sector.id}
                            className="flex items-center  gap-2 p-1 rounded hover:bg-white cursor-pointer transition-colors"
                          >
                            <input
                              type="checkbox"
                              checked={tempSelectedSectors.includes(sector.id)}
                              onChange={() => handleSectorToggle(sector.id)}
                              className="w-3 h-3 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                            />
                            <span className="text-gray-700 text-[0.72rem]">{sector.name}</span>
                          </label>
                        ))}
                        {filteredSectors.length === 0 && (
                          <p className="text-gray-500 text-sm text-center py-4">No sectors found</p>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* Countries Filter */}
                <div className="bg-gray-50 px-2 rounded-lg border border-gray-200">
                  <div 
                    className="py-1 border-b border-gray-200 flex items-center justify-between cursor-pointer hover:bg-gray-100"
                   
                  >
                    {/* onClick={() => setCountriesExpanded(!countriesExpanded)} */}
                    <div className="flex items-center gap-2">
                      <h3 className="text-xs  font-semibold text-gray-900">Countries</h3>
                      {tempSelectedCountries.length > 0 && (
                        <span className="bg-blue-100 text-blue-700 text-xs font-medium px-1.5 p-0.5 rounded-full">
                          {tempSelectedCountries.length}
                        </span>
                      )}
                    </div>
                    {/* {countriesExpanded ? <ChevronUp size={14} /> : <ChevronDown size={14} />} */}
                  </div>
                  
                  {countriesExpanded && (
              <div className="p-2 flex flex-col gap-2">
                <div className="relative">
                  <Search className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-400" size={12} />
                  <input
                    type="text"
                    placeholder="Search countries..."
                    value={countrySearch}
                    onChange={(e) => setCountrySearch(e.target.value)}
                    className="w-full pl-6 pr-4 py-1 text-[0.7rem] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                {/* Clear all button (same style as sectors, optional) */}
                {/* {selectedCountries.length > 0 && (
                  <button
                    onClick={clearAllCountries}
                    className="text-xs text-blue-600 hover:text-blue-700 font-medium mb-3"
                  >
                    Clear all
                  </button>
                )} */}

                <div className="max-h-[14rem] overflow-y-auto space-y-2">
                  {filteredCountries.map((country) => (
                    <label
                      key={country.code}
                      className="flex items-center gap-2 p-1 rounded hover:bg-white cursor-pointer transition-colors"
                    >
                      <input
                        type="checkbox"
                        checked={tempSelectedCountries.includes(country.code)}
                        onChange={() => handleCountryToggle(country.code)}
                        className="w-3 h-3 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                      />
                      <span className="text-gray-700 text-[0.72rem]">
                        {country.name}
                      </span>
                    </label>
               ))}

        {filteredCountries.length === 0 && (
          <p className="text-gray-500 text-sm text-center py-4">
            No countries found
          </p>
        )}
      </div>
    </div>
               )}

                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="flex w-full items-center rounded-lg justify-between px-2 py-1.5 border-t border-gray-200 bg-gray-50">
              {/* <button
                onClick={clearAll}
                className="px-4 py-2 text-gray-700 hover:text-gray-900 font-medium transition-colors"
              >
                Clear All
              </button> */}
              <div className="flex ml-auto gap-3">
             <button
                                onClick={(e) => {
                  e.stopPropagation();
                  cancelModal()
                }}
                  className="px-2  py-1 font-semibold text-[0.7rem] border border-gray-300 text-gray-700 rounded-full hover:bg-gray-100 transition-colors"
                >
                  Cancel
                </button>
                           <button
  onClick={(e) => {
    e.stopPropagation();
    applyFilters();
  }}
  disabled={!hasFiltersChanged}
  className={`px-3 py-1 font-semibold text-[0.7rem] rounded-full transition-colors font-medium ${
    hasFiltersChanged 
      ? 'bg-[#B2853D] text-white hover:bg-[#9a6f31] cursor-pointer' 
      : 'bg-[#B2853D] text-white opacity-70 cursor-not-allowed'
  }`}
>
  Apply 
</button>
              </div>
            </div>

        </div>
      )}  
            </div>
            )}
             
          </div>
        </div>

        <div className="flex gap-6 items-center mb-4">
          <div onClick={() => {
  if (!isLoading) {
    setMenu('All');
  }
}} className={`text-xs font-semibold flex cursor-pointer flex flex-col items-center ${
  currentMenu === 'All' ? 'text-gray-333' : 'text-gray-400'
}`}>
            <div className='flex gap-1'>All Jobs  {currentMenu==='All'&&(
            <div>({totalJobs})</div>
            )}</div>
           
            {currentMenu==='All'&&(
            <div className='w-full h-[2px]  bg-[#B2853D]'></div>
            )}
           
            {/* <span className="flex items-center justify-center text-xs font-semibold text-white mph-primary-bg rounded-full" style={{ width: 20, height: 20 }}>
              {filteredJobs.length}
            </span> */}
          </div>
          {isAuthed&&(
           <div onClick={() => {
  if (!isLoading) {
    setMenu('Recommended')
  }
}}  className={`text-xs font-semibold cursor-pointer flex flex-col items-center ${
  currentMenu === 'Recommended' ? 'text-gray-333' : 'text-gray-400'
}`}>
          <div className='flex gap-1'>Recommended Jobs
             {currentMenu==='Recommended'&&(
            <div>({totalJobs})</div>
             )}
          </div>
           {currentMenu==='Recommended'&&(
            <div className='w-full h-[2px]  bg-[#B2853D]'></div>
            )}
            {/* <span className="flex items-center justify-center text-xs font-semibold text-white mph-primary-bg rounded-full" style={{ width: 20, height: 20 }}>
              {filteredJobs.length}
            </span> */}
          </div>
          )}
             {isAuthed&&(
            <div onClick={() => {
  if (!isLoading) {
    setMenu('Applied');
  }
}}  className={`text-xs font-semibold cursor-pointer flex flex-col items-center ${
  currentMenu === 'Applied' ? 'text-gray-333' : 'text-gray-400'
}`}>
         

           <div className='flex gap-1'>Applied Jobs
             {currentMenu==='Applied'&&(
            <div>({totalJobs})</div>
             )}
          </div>
            {currentMenu==='Applied'&&(
            <div className='w-full h-[2px]  bg-[#B2853D]'></div>
            )}
            {/* <span className="flex items-center justify-center text-xs font-semibold text-white mph-primary-bg rounded-full" style={{ width: 20, height: 20 }}>
              {filteredJobs.length}
            </span> */}
          </div>
          )}
          {/* <a href="#" className="mph-primary font-semibold text-xs">View all</a> */}
        </div>
      </div>

      {/* Scrollable Jobs Grid */}
      {!isLoading &&(
      <div ref={divRef} onScroll={handleScroll} className="flex-1 overflow-y-auto pr-2 pb-2">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-col-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4  gap-5">
          {filteredJobs.map(job => (
            <JobCard key={job.id} myjob={job} onApplyJob={onApplyJob} isValidate={isValidate} applyingJobId={applyingJobId} candidateId={candidateId} resumecandidate={resumecandidate} />
          ))}
        </div>
                {filteredJobs.length === 0 && (
            <div className="text-center text-gray-666 mt-8 flex flex-col items-center">
              <FiInfo className="text-2xl mb-2" />
              <span>
                
                {currentMenu === 'Recommended'
                  ? 'No jobs found matching your profile.'
                  : 'No job applications yet.'}
              </span>
            </div>
          )}
      </div>
      )}
        {isLoading &&(
      <div className="flex h-full items-center justify-center overflow-y-auto pr-2 pb-2">
         <Loader message="Loading jobs" size={100} />
      </div>
      )}
    </section>
  );
};

export default JobList;